module.exports = __webpack_public_path__ + "static/media/trashcan.536c24ec.svg";